<ng-container *ngIf="updateResult?.declineRecalculationResultCode === DeclineRecalculationResultCode.Success">
<ifc-base-dialog title="Transaction declined"
                 (actionClicked)="onActionClicked()">
  <ng-template #content>
    <p class="secondary-text sub-title">
      Subsequent payments have been recalculated to reflect the correct P&amp;I split after this decline. The following loan state changes took effect immediately:
    </p>
    <table mat-table
           [dataSource]="tableData"
           class="mat-elevation-z4 table">
      <ng-container matColumnDef="label">
        <th mat-header-cell
            *matHeaderCellDef
            class="header-cell"> </th>
        <td mat-cell
            *matCellDef="let element"
            class="table-cell table-cell--label"> {{ element.label }} </td>
      </ng-container>

      <ng-container matColumnDef="oldValue">
        <th mat-header-cell
            *matHeaderCellDef
            class="header-cell">Old Values</th>
        <td mat-cell
            *matCellDef="let element"
            class="table-cell table-cell--value"> {{ element.oldValue | currency }} </td>
      </ng-container>

      <ng-container matColumnDef="newValue">
        <th mat-header-cell
            *matHeaderCellDef
            class="header-cell"> New Values </th>
        <td mat-cell
            *matCellDef="let element"
            class="table-cell table-cell--value"> {{ element.newValue | currency }} </td>
      </ng-container>

      <tr mat-header-row
          *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row
          *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-template>
</ifc-base-dialog>
</ng-container>
